import * as THREE from "three";
import GameConfig from "../config";
import meshCloner from "../utils/meshCloner";

export default class DecoElement {

    static createMesh({blueprint, position, scale}){
        const mesh = meshCloner(blueprint, false, true);
        mesh.rotation.x = -Math.PI / 2;
        mesh.castShadow = true;
        mesh.scale.set(scale, scale, scale)
        mesh.position.copy(position);
        return mesh;
    }

    constructor({scene, mesh, position = new THREE.Vector3(), scale = 1}) {
        this.scene = scene;
        this.mesh = mesh;
        this.scene.add(mesh);
        this.moveTo(position);
    }

    moveTo(position){
        this.mesh.position.copy(position);
    }

    destroy(){
        this.mesh.geometry.dispose();
        this.scene.remove(this.mesh);
    }
}